import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

interface TabTitleProps {
  title: string
  subtitle: string
}

export function TabTitle({ title, subtitle }: TabTitleProps) {
  return (
    <Stack>
      <Text bold={true} variant="body1">
        {title}
      </Text>
      <Text sx={{ fontWeight: 400 }} variant="body1">
        {subtitle}
      </Text>
    </Stack>
  )
}
